// extracted by mini-css-extract-plugin
export default {"section":"TitleSection_section__DSnzp","title":"TitleSection_title__mvUUy"};